import Alpine from 'alpinejs'
import { SET_ACTIVE_TAB } from '@/constants/tab-events'

document.addEventListener('alpine:init', () => {
  Alpine.data('tab', (tabIds, id, active) => ({
    tabIds,
    id,
    active,

    onClick() {
      const tabIds = Array.from(this.tabIds)

      this.$dispatch(SET_ACTIVE_TAB, {
        tabIds,
        id: this.id,
      })
    },

    eventHandlers: {
      [`@${SET_ACTIVE_TAB}.window`]() {
        const { tabIds, id } = this.$event.detail

        if (!tabIds.includes(this.id)) return

        this.active = this.id === id
      },
    },

    get classes() {
      return {
        'section-tabs-tab--active': this.active,
      }
    },
  }))
})
